import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RotateOverlay from './components/RotateOverlay';
import { setBackButtonUrl } from '../../store/uiSlice';
import { ASSET, fetchProgress } from '../../utils/sopGame';
import { reportApiRole } from '../../functions/sendReport';
import './thankyou.css';

function formatScoreTime(timee) {
  if (!timee) return '00:00';
  const parts = String(timee).split(':');
  if (parts.length < 3) return timee;
  return `${parts[1]}:${parts[2]}`;
}

export default function ThankYouPage() {
  const user = useSelector((s) => s.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [points, setPoints] = useState(0);
  const [timeLabel, setTimeLabel] = useState('00:00');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(setBackButtonUrl(user?.backButtonRedirect || process.env.REACT_APP_BASE_URL || '/'));
  }, [dispatch, user]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const prog = await fetchProgress(user);
        if (cancelled) return;
        setPoints(Number(prog.points) || 0);
        setTimeLabel(formatScoreTime(prog.timee));
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  const isGuest = user && reportApiRole(user) === 'GUEST_USER';

  return (
    <div className="sop-thankyou">
      <RotateOverlay />
      <img className="sop-thankyou-logo" src={ASSET.img('thankyou.png')} alt="Thank you" />
      {loading ? (
        <div className="sop-game-loader" style={{ margin: '24px auto' }} />
      ) : (
        <p className="sop-thankyou-score">
          Your score is {points} out of 25 in {timeLabel} minutes.
        </p>
      )}
      {isGuest ? (
        <button type="button" className="sop-thankyou-lb" onClick={() => navigate('/leaderboard')}>
          Leaderboard
        </button>
      ) : null}
    </div>
  );
}
